export const passwordSpecialChars = /[!@#$%^&*(),.?":{}|<>/\\_]+/;
export const passwordNumbers = /\d+/;
export const passwordCase = /[a-zA-Z]+/;

export function isValidPassword(password: string) {
  const minLength = password.length >= 6;
  const maxLength = password.length <= 64;
  const hasSpecialChar = password.match(passwordSpecialChars) !== null;
  const hasNumber = password.match(passwordNumbers) !== null;
  const hasUpperLowerCase = password.match(passwordCase) !== null;

  const isValid = minLength && maxLength && hasSpecialChar && hasNumber && hasUpperLowerCase;

  return {
    isValid,
    minLength,
    maxLength,
    hasSpecialChar,
    hasNumber,
    hasUpperLowerCase,
  };
}
